export const formatDistance = (meters: number): string => {
  if (meters < 1) {
    return `${(meters * 100).toFixed(2)} см`;
  } else if (meters < 1000) {
    return `${meters.toFixed(2)} м`;
  } else {
    return `${(meters / 1000).toFixed(2)} км`;
  }
};
